import React from "react"
import { MultiStepFlowContainer } from "../../Components/MultiStepFlow"
import { Paragraph } from "../../Components/Paragraph"
import { MentorActivities as Activities} from "../../constants/stepRegistry"
import { useOutletContextPlan } from "../../hooks/useOutletContextPlan"
import { useNavigate } from "react-router-dom"
import { isStepLocked } from "../../lib/plan"
import { PLAN_STATUS } from "../../constants/planStatus"
import LockedStep from "../../Components/LockedStep"
import { MoreInfoVideoModal } from "../../Components/MoreInfoVideoModal"
import { INVITE_STUDENT_RESOURCE_URL, VALUE_OF_IN_PERSON_GATHERING_RESOURCE_URL } from "../../constants/resources"

/**
 * MentorActivies
 *
 */
const MentorActivities = () => {
  const { student, plan, currentStep } = useOutletContextPlan()
  const navigate = useNavigate()
  const steps = [
    {
      id: "complete-mentor-activities",
      encouragement: "✏️",
      encouragementClassName: "text-3xl",
      title: "Complete Mentor Activities",
      renderCustomContent: () => {
        return (
          <div className="mx-auto flex max-w-xl flex-col items-center justify-center gap-2 text-center">
            <Paragraph>It's time to love on your Student!</Paragraph>
            <Paragraph>
              These three Mentor Activities will give your student encouragement and support.
            </Paragraph>
            <div className="mx-auto my-6 flex max-w-md flex-col gap-8">
              {Activities.map((activity, index) => (
                <Activity key={index} activity={activity} />
              ))}
            </div>
            <Paragraph>
              For a truly powerful experience, bringing the Student and Mentors together for an
              in-person Gathering
            </Paragraph>
            <MoreInfoVideoModal
              src={VALUE_OF_IN_PERSON_GATHERING_RESOURCE_URL}
              text=""
              postText="The Value of an In-Person Gathering"
              title="The Value of an In-Person Gathering"
              textClassName="text-brand no-underline"
            />
          </div>
        )
      },
    },
  ]

  const handleComplete = (values, stepId) => {
    if (!plan?.token) {
      console.error("Plan token is missing")
      return
    }
    navigate(`/plan/${plan.token}/activities`)
  }

  if (isStepLocked(PLAN_STATUS.SIT_WITH_STUDENT, currentStep)) {
    return <LockedStep />
  }

  return (
    <MultiStepFlowContainer
      steps={steps}
      initialValues={{}}
      onBack={() => {
        navigate(`/plan/${plan?.token}/checklist`)
        return true
      }}
      alwaysShowBackButton={true}
      onComplete={handleComplete}
      showProgress={false}
      completeButtonText="Let's get started!"
      containerClassName="max-w-md"
      fieldWidth="w-64 mx-auto"
      fieldContainerClassName="flex flex-col items-center"
    />
  )
}

const Activity = ({ activity }) => {
  return (
    <div className="flex flex-row items-start justify-start gap-4 text-left">
      <img className="h-16 w-16" src={activity.image} alt={activity.name} />
      <div className="flex flex-col items-start justify-start">
        <div className="mb-2 flex flex-col justify-start sm:mb-0 sm:flex-row sm:items-center sm:gap-2">
          <div className="text-lg font-bold">{activity.altTitle ?? activity.title}</div>
          <div className="text-sm text-gray-500">{activity.description}</div>
        </div>
        <div className="text-sm text-gray-600">{activity.details}</div>
      </div>
    </div>
  )
}
export default MentorActivities
